import { takeLatest, put, call, SagaReturnType } from 'redux-saga/effects';
import { dailySessionNotes } from '../../actions/constant';
import dailySessionNotesService from 'src/services/apiServices/dailySessionNotes/dailySessionNotes';

const {
  DELETE_DAILY_SESSION_NOTE_REQUEST,
  DELETE_DAILY_SESSION_NOTE_SUCCESS,
  DELETE_DAILY_SESSION_NOTE_FAILURE,
  DELETE_DAILY_SESSION_NOTE_LOADING,
} = dailySessionNotes;

function* deleteDailySessionNote(action: any): SagaReturnType<any> {
  try {
    yield put({ type: DELETE_DAILY_SESSION_NOTE_LOADING });
    const response = yield call(
      dailySessionNotesService.deleteDailySessionNote,
      action?.payload
    );
    if (response?.status === 200) {
      yield put({ type: DELETE_DAILY_SESSION_NOTE_SUCCESS, payload: response.data });
    } else {
      throw response.data;
    }
  } catch (error) {
    yield put({ type: DELETE_DAILY_SESSION_NOTE_FAILURE, payload: error });
  }
}

function* deleteDailySessionNoteSaga() {
  yield takeLatest(DELETE_DAILY_SESSION_NOTE_REQUEST, deleteDailySessionNote);
}

export default deleteDailySessionNoteSaga;
